var map = {
	"./de.json": 998,
	"./empty.json": 999,
	"./es.json": 1000,
	"./fr.json": 1001,
	"./it.json": 1002,
	"./ja.json": 1003,
	"./ko.json": 1004,
	"./lt.json": 1005,
	"./pt.json": 1006,
	"./ru.json": 1007,
	"./tr.json": 1008,
	"./zh.json": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;